import React, { useEffect } from "react";
import { NavLink as Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import { supabase } from "../../client";

const Dashboard = ({ children }) => {
  const history = useHistory();
  const signout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    history.push("/");
  };

  useEffect(() => {
    !supabase.auth.user() && history.push("/login");
  }, [history]);

  return (
    <LargeContainer style={{ marginTop: "8em" }}>
      <MainContainer halign="space-between">
        <Left>
          <NavLink to="/dashboard/" exact>
            <SidebarTab>DASHBOARD</SidebarTab>
          </NavLink>
          <NavLink to="/dashboard/orders">
            <SidebarTab>ORDERS</SidebarTab>
          </NavLink>

          <NavLink to="/dashboard/address">
            <SidebarTab>ADDRESSES</SidebarTab>
          </NavLink>
          <NavLink to="!#" onClick={signout}>
            <SidebarTab>LOGOUT</SidebarTab>
          </NavLink>
        </Left>
        {children}
      </MainContainer>
    </LargeContainer>
  );
};
const Left = styled.div`
  width: 20%;
`;

const SidebarTab = styled.div`
  padding: 1em;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #2c2c2c;
  border: 1px solid #444444;
  cursor: pointer;
`;
const NavLink = styled(Link)`
  color: white;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s;
  :hover {
    color: #83aa4c;
  }
  &.active {
    color: #83aa4c;
  }
`;

export default Dashboard;
